import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles({
	root: {
		border: `1px solid ${colors.gray[100]}`,
		borderRadius: 8,
		"&:before": {
			opacity: 0
		},
		"&.Mui-expanded": {
			margin: 0
		}
	},
	expandAccordionIcon: {
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[200]),
		borderRadius: 32,
		color: colors.purple[600],
		padding: 4
	},
	expandedAccordion: {
		"&.MuiAccordionSummary-expandIcon.Mui-expanded": {
			transform: "rotate(90deg)"
		}
	},
	accordionSummary: {
		cursor: "auto !important",
		userSelect: "auto !important" as "auto"
	},
	channelSettingsButton: {
		background: "transparent"
	},
	statementButton: {
		background: colors.gray[0]
	},
	accountRestrictionInfoButton: {
		minWidth: 24,
		minHeight: 24,
		backgroundColor: colors.red["50"],
		borderRadius: 999
	},
	containerIcon: {
		width: 24,
		height: 24
	},
	wabaIconContainer: {
		borderRadius: 6,
		width: 34,
		height: 34,
		...ColorUtil.getBackgroundAndContrastColor(colors.green[600])
	},
	whatsappIcon: {
		color: colors.gray[0]
	},
	channelInfoText: {
		fontWeight: 400,
		fontSize: 16,
		color: colors.gray[800]
	},
	statusChip: {
		fontWeight: 400,
		fontSize: 16,
		padding: "4px 14px 4px 14px"
	},
	formLabel: {
		fontWeight: 400,
		fontSize: 12,
		color: colors.gray[600]
	},
	saveButton: {
		fontWeight: 400,
		fontSize: 14,
		color: colors.gray[0]
	},
	walletBalanceText: {
		color: colors.purple[600]
	},
	walletBalanceTextNegative: {
		color: colors.red[400]
	},
	infoIconSize: {
		width: 16,
		height: 16
	},
	reconnectButton: {
		background: colors.gray[0],
		animation: "$reconnectPulse 1.5s ease-in-out infinite"
	},
	"@keyframes reconnectPulse": {
		"0%, 100%": { opacity: 1 },
		"50%": { opacity: 0.4 }
	},
	disconnectLinkText: {
		color: colors.red[500],
		cursor: "pointer",
		textDecoration: "underline"
	}
})

export default useStyles
